module.exports = __webpack_public_path__ + "img/20190620162354484.60e229b6.png";